import type { PlatformType } from '@/types'

const IOS_IDENTIFIER = 'PlaygamaIOSApp'
const ANDROID_IDENTIFIER = 'PlaygamaAndroidApp'
const VERSION_REGEX = new RegExp(`(?:${IOS_IDENTIFIER}|${ANDROID_IDENTIFIER})/([\\d.]+)`)

export interface ParsedDevice {
    platform: PlatformType
    isNativeIos: boolean
    isNativeAndroid: boolean
    appVersion: string | undefined
}

export function resolvePlatform(userAgent: string, platformOverride?: PlatformType): PlatformType {
    return platformOverride || parseDevice(userAgent).platform
}

export function parseDevice(ua: string): ParsedDevice {
    const isNativeIos = ua.includes(IOS_IDENTIFIER)
    const isNativeAndroid = ua.includes(ANDROID_IDENTIFIER)

    const versionMatch = ua.match(VERSION_REGEX)
    const appVersion = versionMatch ? versionMatch[1] : undefined

    let platform: PlatformType
    if (isNativeIos) {
        platform = 'ios'
    } else if (isNativeAndroid) {
        platform = 'android'
    } else if (ua.match(/(iPhone|iPad|iPod)/)) {
        platform = 'ios'
    } else if (ua.match(/Android/)) {
        platform = 'android'
    } else {
        platform = 'desktop'
    }

    return { platform, isNativeIos, isNativeAndroid, appVersion }
}
